import React from 'react';
import { FullPageMessage } from '../../../../common/FullPageMessage';

export const ActivityTimelineNoSelection = () => {
  return <FullPageMessage title={'No Selection'} subtitle={'Choose an item from the sidebar to begin.'} />;
};
